import { useEffect, useState } from 'react';

type GetImageHookProps = {
  extractImage: () => Promise<string>;
  condition?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  valueToListen?: any;
};

type GetImageHook = {
  image: string | undefined;
  isLoaded: boolean;
};

export const useGetImage = ({ extractImage, condition = true, valueToListen }: GetImageHookProps): GetImageHook => {
  const [isLoaded, setIsLoaded] = useState<boolean>(true);
  const [image, setImage] = useState<string | undefined>();

  const fetchImage = async () => {
    const newImage = await extractImage();
    setImage(newImage);
    setIsLoaded(true);
  };

  useEffect(() => {
    if (condition && !image) {
      fetchImage();
    }
  }, [condition]);

  useEffect(() => {
    if (valueToListen) {
      setImage(undefined);
      setIsLoaded(false);
      fetchImage();
    }
  }, [valueToListen]);

  return { image, isLoaded };
};
